{
	"hoursShort": "{count} ч",
	"templates": {
		"subsystems": {
			"ru:school": "Школа",
			"ru:university": "Университет",
			"ru:ege": "ЕГЭ",
			"ru:oge": "ОГЭ",
			"ru:vpr": "ВПР",
			"us:high-school": "Старшая школа (США)",
			"us:ap": "AP",
			"us:sat": "SAT",
			"us:mcat": "MCAT",
			"us:usmle": "USMLE",
			"uk:gcse": "GCSE",
			"uk:a-levels": "A-Levels",
			"kz:school": "Школа KZ",
			"kz:ent": "ЕНТ",
			"de:abitur": "Abitur",
			"fr:bac": "Baccalauréat",
			"cn:gaokao": "Gaokao",
			"in:cbse": "CBSE",
			"in:icse": "ICSE",
			"other": "Другое"
		}
	},
	"detail": {
		"back": "К списку планов"
	},
	"subsection": {
		"minutes": "{count} мин",
		"doneShort": "готово"
	},
	"generate": {
		"title": "Создать учебный план",
		"subtitle": "AI построит план под твою цель и доступное время",
		"bindings": {
			"title": "Прикрепить материалы и папки",
			"hint": "Необязательно. ИИ составит план на основе содержимого выбранных материалов и папок.",
			"materials": "Материалы",
			"collections": "Папки"
		},
		"fields": {
			"completionDate": "Дата завершения обучения",
			"examDateOptional": "(необязательно)",
			"weeklyHours": "Часов в неделю",
			"goal": "Цель / описание",
			"goalPlaceholder": "Например: подготовиться к ЕГЭ Биология за 4 месяца",
			"title": "Название плана",
			"titlePlaceholder": "Например: Подготовка к экзамену"
		},
		"submit": "Создать план",
		"cancel": "Отмена",
		"generating": "Создаём твой план...",
		"stepAnalyze": "Анализируем материалы",
		"stepStructure": "Строим разделы",
		"stepActivities": "Расписываем активности",
		"stepReady": "Готово",
		"quotaExceeded": "Лимит планов исчерпан",
		"quotaUpgradeCTA": "Перейти на Plus",
		"errorToast": "Не удалось создать план",
		"failedTitle": "Не получилось сгенерировать план",
		"failedHint": "Попробуйте ещё раз или измените параметры. Квота не списана.",
		"retry": "Повторить"
	},
	"sourceStale": {
		"badge": "Источник изменился",
		"hint": "Материалы источника обновились после генерации. Перегенерируйте, чтобы учесть изменения.",
		"regenerate": "Обновить"
	},
	"loadSettings": {
		"title": "Настройки нагрузки",
		"subtitle": "Эти настройки применяются ко всем планам.",
		"minutesLabel": "Минут в день",
		"daysLabel": "Рабочие дни",
		"minDayHint": "Выберите хотя бы один день",
		"saved": "Настройки сохранены, расписание пересчитывается",
		"error": "Не удалось сохранить настройки"
	},
	"calendar": {
		"title": "Учебный календарь",
		"subtitle": "Уроки, экзамены и повторы всех планов на месяц",
		"buttonLabel": "Календарь",
		"overrunWarning": "Материал не успевает до экзамена",
		"minutesTotal": "{count, plural, one {# минута} few {# минуты} many {# минут} other {# минуты}}",
		"daysToExam": "{count, plural, =0 {Экзамен сегодня} one {# день до экзамена} few {# дня до экзамена} many {# дней до экзамена} other {# дня до экзамена}}",
		"moreLessons": "ещё {count}",
		"filterPlans": "Планы",
		"moved": "Урок перенесён на {date}",
		"rescheduled": "Расписание обновлено",
		"todayButton": "Сегодня",
		"prevMonth": "Предыдущий месяц",
		"nextMonth": "Следующий месяц",
		"prevWeek": "Предыдущая неделя",
		"nextWeek": "Следующая неделя",
		"filterPlansCount": "Планы ({count})",
		"filterReset": "Сбросить",
		"filterSearchPlaceholder": "Поиск плана",
		"filterNoMatch": "Планы не найдены",
		"filterSelectAll": "Выбрать все",
		"moveTo": "Перенести на…",
		"moveError": "Не удалось перенести урок",
		"dayEmpty": "На этот день ничего не запланировано",
		"dayNoLessons": "Уроков на этот день нет",
		"minutesValue": "{count, plural, one {# минута} few {# минуты} many {# минут} other {# минуты}}",
		"viewMonth": "Месяц",
		"viewAgenda": "Список",
		"examDayDropHint": "День экзамена — резерв под повтор",
		"overrunCta": {
			"cap": "Больше времени в день",
			"date": "Сдвинуть дату",
			"scope": "Сократить план"
		},
		"examCardTitle": "Экзамен: {planTitle}",
		"lessonLabel": "Урок",
		"srsLabel": "Повтор",
		"examLabel": "Экзамен",
		"openLesson": "Открыть",
		"review": "Повторить",
		"overdueShort": "просрочено",
		"srsEntryLine": "{count, plural, one {# к повтору} few {# к повтору} many {# к повтору} other {# к повтору}}",
		"examEntryLine": "Экзамен: {planTitle}",
		"noExamSoon": "Экзаменов впереди нет",
		"selectDay": "Выбрать день",
		"dayNamesShort": [
			"Пн",
			"Вт",
			"Ср",
			"Чт",
			"Пт",
			"Сб",
			"Вс"
		],
		"emptyPeriod": "В этом периоде занятий курса нет. Ближайшее — {date}.",
		"emptyPeriodJump": "Перейти"
	},
	"intro": {
		"title": "Расписание считается, а не заполняется",
		"body": "Занятия всех активных курсов раскладываются сами — в пределах дневного лимита минут и до даты экзамена.",
		"bullets": [
			"Один лимит минут в день на все курсы сразу",
			"Перенесённое вручную занятие пересчёт не двигает",
			"Если материал не влезает до экзамена — предупредим"
		]
	}
}
